<script lang="ts">
import ButtonComponent from "@/components/Common/ButtonComponent.vue";
import FileInputComponent from "@/components/Common/FileInputComponent.vue";
import InputComponent from "@/components/Common/InputComponent.vue";
import StatusModal from "@/components/Modals/StatusModal.vue";
import * as Sentry from "@sentry/vue";
import axios from "axios";
import { Getter } from "s-vuex-class";
import { Options, Vue } from "vue-class-component";
import { toast } from "vue3-toastify";

@Options({
  components: {
    StatusModal,
    FileInputComponent,
    ButtonComponent,
    InputComponent,
  },
})
export default class ContactForm extends Vue {
  @Getter("appName") private appName: string | undefined;
  private fullName = "";
  private phone = "";
  private feedbackPhone = "";

  private hasRequest = false;

  private typeForm: "easy" | "form" | "feedback" = "easy";

  private workType: "driver" | "courier" = "driver";

  private fileSTS: File | null = null;
  private filePassport: File | null = null;
  private fileSelfiePassport: File | null = null;
  private fileTaxiLicense: File | null = null;
  private fileDriverLicense: File | null = null;
  private successDialog = false;

  private async sendEasyForm() {
    this.hasRequest = true;

    await axios
      .post("/connect-form", {
        full_name: this.fullName,
        phone: "+7 " + this.phone,
        domain: window.location.hostname,
        type: this.typeForm,
      })
      .then(async (response) => {
        if (response.data.response == "success_form") {
          if (this.feedbackPhone) {
            await this.sendFeedback();
            this.sendToStore();
          } else {
            this.typeForm = "feedback";
          }
        } else {
          toast("Ошибка с отправкой формы, мы уже исправляем ее!", {
            autoClose: 4000,
            type: "error",
          });

          Sentry.captureException("Error with send contact form", {
            extra: {
              url: window.location.hostname,
            },
          });
        }
      })
      .catch(() => {
        toast("Ошибка с отправкой формы, мы уже исправляем ее!", {
          autoClose: 4000,
          type: "error",
        });

        Sentry.captureException("Error with send contact form", {
          extra: {
            url: window.location.hostname,
          },
        });
      })
      .finally(() => {
        this.hasRequest = false;
      });
  }

  private async sendToStore() {
    if (this.$IS_SAFARI) {
      this.$router.replace({ name: "AppleStore" });
    } else {
      this.$router.replace({ name: "AndroidStore" });
    }
  }

  private async sendFeedback() {
    this.hasRequest = true;
    await axios
      .post("/connect-form", {
        type: "feedback",
        phone: "+7 " + this.phone,
        feedbackPhone: "+7 " + this.feedbackPhone,
        domain: window.location.hostname,
      })
      .then((response) => {
        if (response.data.response === "success_form") {
          this.sendToStore();
          Sentry.captureMessage("Success send feedback contact form");
        } else {
          this.$router.replace({ name: "LoginPage" });

          Sentry.captureException("Error with send feedback  in contact form", {
            extra: {
              url: window.location.hostname,
            },
          });
        }
      })
      .catch(() => {
        toast("Ошибка с отправкой формы, мы уже исправляем ее!", {
          autoClose: 4000,
          type: "error",
        });

        Sentry.captureException("Error with send contact form", {
          extra: {
            url: window.location.hostname,
          },
        });
      })
      .finally(() => {
        this.hasRequest = false;
      });
  }

  private async sendFullForm() {
    this.hasRequest = true;
    const formData = new FormData();
    formData.append("filePassport", this.filePassport as File);
    formData.append("fileSelfiePassport", this.fileSelfiePassport as File);

    formData.append("full_name", this.fullName);
    formData.append("phone", "+7 " + this.phone);
    formData.append("domain", window.location.hostname);
    formData.append("type", this.typeForm);

    if (this.workType == "driver") {
      formData.append("fileTaxiLicense", this.fileTaxiLicense as File);
      formData.append("fileDriverLicense", this.fileDriverLicense as File);
      formData.append("fileSTS", this.fileSTS as File);
    }

    await axios
      .post("/connect-form", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (response) => {
        if (response.data.response == "success_form") {
          if (this.feedbackPhone) {
            await this.sendFeedback();
            this.sendToStore();
          } else {
            this.typeForm = "feedback";
          }
          Sentry.captureMessage("Success send connect contact form");
        } else {
          toast("Ошибка с отправкой формы, мы уже исправляем ее!", {
            autoClose: 4000,
            type: "error",
          });

          Sentry.captureException("Error with send contact form", {
            extra: {
              url: window.location.hostname,
            },
          });
        }
      })
      .catch(() => {
        toast("Ошибка с отправкой формы, мы уже исправляем ее!", {
          autoClose: 4000,
          type: "error",
        });

        Sentry.captureException("Error with send contact form", {
          extra: {
            url: window.location.hostname,
          },
        });
      })
      .finally(() => {
        this.hasRequest = false;
      });
  }

  created() {
    if (this.$route.query.phone) {
      window.open("tel:" + this.$route.query.phone);
    }

    if (this.$route.query.feedbackPhone) {
      this.feedbackPhone = this.$route.query.feedbackPhone.slice(1);
    }

    console.log("this.feedbackPhone", this.feedbackPhone);
  }
}
</script>

<template>
  <div class="p-4 mx-auto max-w-[900px] select-none">
    <div class="mx-auto w-max text-center">
      <img
        src="../../../assets/logo.png"
        alt="logo"
        class="rounded-md w-24 h-24 mx-auto"
      />
      <div class="mt-2 text-center">{{ appName }}</div>
    </div>

    <StatusModal :state="successDialog" />

    <div
      class="flex items-center text-center mt-4 cursor-pointer space-x-5"
      v-if="typeForm === 'form' || typeForm === 'easy'"
    >
      <div
        class="px-2 py-2 rounded-md w-full border border-primary"
        :class="{ 'bg-primary': typeForm == 'easy' }"
        @click="typeForm = 'easy'"
      >
        Свяжитесь со мной
      </div>
      <div
        class="px-2 py-2 rounded-md w-full border border-primary"
        :class="{ 'bg-primary': typeForm == 'form' }"
        @click="typeForm = 'form'"
      >
        Создайте профиль
      </div>
    </div>

    <div v-auto-animate>
      <div class="space-y-3 mt-4" v-if="typeForm == 'form'">
        <div>
          <div>Тип работы</div>
          <div class="flex items-center space-x-4 mt-1">
            <div class="flex items-center">
              <input
                v-model="workType"
                type="radio"
                value="driver"
                name="default-radio"
                class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300"
              />
              <label
                for="default-radio-2"
                class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >Водитель</label
              >
            </div>
            <div class="flex items-center">
              <input
                v-model="workType"
                type="radio"
                value="courier"
                name="default-radio"
                class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300"
              />
              <label
                for="default-radio-2"
                class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                >Курьер</label
              >
            </div>
          </div>
        </div>

        <div>
          <div>ФИО <span class="text-red font-medium">*</span></div>
          <InputComponent
            v-model="fullName"
            :model="fullName"
            placeholder="Сидоров Иван Петрович"
          />
        </div>

        <div>
          <div>Номер телефона <span class="text-red font-medium">*</span></div>
          <InputComponent
            v-model="phone"
            type="tel"
            :model="phone"
            placeholder="(928) 738 25-62"
            mask="(###) ### ##-##"
            prefix="+7"
            maxlength="15"
          />
        </div>

        <div>
          <div>Фото паспорта <span class="text-red font-medium">*</span></div>
          <FileInputComponent @fileUpload="(val) => (filePassport = val)" />
        </div>
        <div>
          <div>
            Фото с паспортом в руках <span class="text-red font-medium">*</span>
          </div>
          <FileInputComponent
            @fileUpload="(val) => (fileSelfiePassport = val)"
          />
        </div>

        <div v-show="workType == 'driver'">
          <div>
            Водительское удостоверение
            <span class="text-red font-medium">*</span>
          </div>
          <FileInputComponent
            @fileUpload="(val) => (fileDriverLicense = val)"
          />
        </div>

        <div v-show="workType == 'driver'">
          <div>Фото СТС <span class="text-red font-medium">*</span></div>
          <FileInputComponent @fileUpload="(val) => (fileSTS = val)" />
        </div>

        <div v-show="workType == 'driver'">
          <div>
            Лицензия такси <span class="text-gray-400">(если есть)</span>
          </div>
          <FileInputComponent @fileUpload="(val) => (fileTaxiLicense = val)" />
        </div>

        <div class="text-red">
          <span class="font-medium">*</span> - поле обязательное для заполнения
        </div>

        <ButtonComponent
          v-show="workType == 'driver'"
          :disabled="
            fullName.length < 1 ||
            phone.length < 15 ||
            !filePassport ||
            !fileSelfiePassport ||
            !fileDriverLicense ||
            !fileSTS
          "
          :loading="hasRequest"
          title="Создать профиль"
          @clickAction="sendFullForm"
        />
        <ButtonComponent
          v-show="workType == 'courier'"
          :disabled="
            fullName.length < 1 ||
            phone.length < 15 ||
            !filePassport ||
            !fileSelfiePassport
          "
          :loading="hasRequest"
          title="Создать профиль"
          @clickAction="sendFullForm"
        />
      </div>

      <div class="mt-4 space-y-3" v-if="typeForm == 'easy'">
        <div>
          <div>ФИО <span class="text-red font-medium">*</span></div>
          <InputComponent
            v-model="fullName"
            :model="fullName"
            placeholder="Сидоров Иван Петрович"
          />
        </div>

        <div>
          <div>Номер телефона <span class="text-red font-medium">*</span></div>
          <InputComponent
            type="tel"
            v-model="phone"
            maxlength="15"
            :model="phone"
            placeholder="(928) 738 25-62"
            mask="(###) ### ##-##"
            prefix="+7"
          />
        </div>

        <div class="text-red">* - поле обязательное для заполнения</div>

        <ButtonComponent
          :disabled="fullName.length < 1 || phone.length < 15"
          :loading="hasRequest"
          title="Свяжитесь со мной"
          @clickAction="sendEasyForm"
        />
      </div>

      <div class="mt-8" v-if="typeForm == 'feedback'">
        <div class="text-base">
          Ваша заявка успешно отправлена, с вами свяжутся в ближайшее время,
          спасибо!
        </div>

        <div class="mt-8">
          Если вас кто-то пригласил, пожалуйста, впишите его номер телефона ниже
          <InputComponent
            type="tel"
            class="mt-2"
            v-model="feedbackPhone"
            maxlength="15"
            :model="feedbackPhone"
            placeholder="(928) 674 54-72"
            mask="(###) ### ##-##"
            prefix="+7"
          />
        </div>
        <div class="space-y-2 mt-4">
          <ButtonComponent
            title="Отправить"
            :disabled="feedbackPhone.length < 15"
            :loading="hasRequest"
            @clickAction="sendFeedback"
          />
          <ButtonComponent
            title="Закрыть"
            color="greyLight"
            @clickAction="sendToStore"
          />
        </div>
      </div>
    </div>
  </div>
</template>
